import { ICellRendererFunc, ICellRendererParams } from 'ag-grid-community';
import React from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { FieldOption, StatusGroup, TaskType } from 'api/tasks';
import { statusHtmlForOptions } from 'components/organisms/tasks/field-value/task';

type Status = FieldOption<StatusGroup>;

export const getProjectStatusCellRendererFunc = (
  options: Status[],
): ICellRendererFunc => {
  const statusHtmlFor = statusHtmlForOptions(options);

  return (params: ICellRendererParams) => {
    const { value } = params;
    const status = Number(value);
    const statusHtml = statusHtmlFor(TaskType.Task, status);
    const selected = options.find((option) => option.value === status);
    const nameHtml = selected
      ? renderToStaticMarkup(
          <span title={selected.label}>{selected.label}</span>,
        )
      : '';

    return `<div class="spacer spacer-medium">${statusHtml}${nameHtml}</div>`;
  };
};
